import { useState } from "react";
import DefaultButton from "../buttons/defaultButton";
import { Icons } from "../../../utils/icons";
import { useDebounce } from "../../../hooks/useDebounce";

const SearchInput = ({
  id,
  type,
  placeholder,
  required,
  name,
  onChange,
  classnames,
  icon,
  shortKey,
  debounceDelay = 500, // Add debounce delay prop
}) => {
  const [showSearch, setShowSearch] = useState(false);
  const [searchValue, setSearchValue] = useState("");

  // Add debounced onChange
  const debouncedOnChange = useDebounce((value) => {
    if (onChange) {
      onChange({ target: { name, value } });
    }
  }, debounceDelay);

  const handleChange = (e) => {
    const value = e.target.value;
    setSearchValue(value);
    // Use debounced function instead of immediate onChange
    debouncedOnChange(value);
  };

  const handleClose = () => {
    if (searchValue) {
      setSearchValue("");
      if (onChange) {
        onChange({ target: { name, value: "" } });
      }
    }
    setShowSearch(false);
  };

  return (
    <div className="overflow-hidden">
      {!showSearch && (
        <DefaultButton
          varient="iconButton"
          icon={Icons.SEARCH}
          onClick={() => setShowSearch(true)}
        />
      )}

      {/* Search Box */}
      <div
        className={`flex-col gap-1 text-black hidden md:flex absolute w-full bottom-1 left-1 right-1 h-[38px] justify-center items-center
        transition-all duration-500 ease-in-out 
        ${
          showSearch
            ? "translate-x-0 opacity-100 w-[calc(100%-8px)]"
            : "translate-x-full opacity-0 w-0 overflow-hidden "
        }
        `}
      >
        <input
          id={id}
          type={type ? type : "text"}
          placeholder={placeholder || "Search here..."}
          required={!!required}
          name={name}
          value={searchValue}
          // onChange={onChange}
          onChange={handleChange}
          className={`ring-0 w-full focus:ring-0 focus:shadow-none focus:border-0
                  rounded-md border-0 bg-none pl-10 pr-10 text-xs ${classnames}`}
        />
        <span
          className={
            "w-8 h-8 flex justify-center items-center absolute top-1 left-1 text-md"
          }
        >
          {icon ? icon : Icons.SEARCH}
        </span>

        <DefaultButton
          varient="iconButton"
          icon={Icons.CLOSE}
          onClick={handleClose}
          className={
            "w-6 h-10 flex justify-center items-center absolute right-0 text-md border-0 rounded-md"
          }
        />
      </div>
    </div>
  );
};
export default SearchInput;
